import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import {
  studentAddToClassAction,
  studentAddToteacherClass,
  studentListAction,
} from "../Redux/Action/StudentAction";
import { useDispatch, useSelector } from "react-redux";
import SearchBar from "../Components/common/SearchBar";
import { toast } from "react-hot-toast";
import { collectionShareWithPerticulerStudentAction } from "../Redux/Action/CollectionAction";
import { truncateEmail } from "../Util/HelperFunction";
import { classdetailsAction } from "../Redux/Action/ClassAction";
import { useLocation } from "react-router-dom";
import ConfirmModal from "./ConfirmModal";

const StudentsModal = ({ show, handleClose, idval, type }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const groupString = queryParams.get("groups"); // e.g., "3,4,14"
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedType, setSelectedType] = useState(" ");
  const [searchValue, setSearchValue] = useState("");
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);

  const FilterPayload = {
    searchValue: searchValue,
    selectedDepartment: "",
  };

  useEffect(() => {
    dispatch(studentListAction(FilterPayload));
  }, [searchValue]);

  const studentData = useSelector((state) => state?.studentSlice?.students);
  const handleClick = (item) => {
    const isSelected = selectedItems.includes(item._id);

    if (isSelected) {
      // Remove both _id and its group
      setSelectedItems((prev) => prev.filter((id) => id !== item._id));
      setSelectedGroups((prev) => prev.filter((group) => group !== item.group));
    } else {
      // Add both _id and its group
      setSelectedItems((prev) => [...prev, item._id]);

      // Add group only if it's not already added (to avoid duplicates)
      setSelectedGroups((prev) =>
        prev.includes(item.group) ? prev : [...prev, item.group]
      );
    }
  };

  const handleSubmit = async (idval) => {
    try {
      const Payload = {
        classId: idval,
        student: selectedItems,
      };
      const res = await dispatch(studentAddToClassAction(Payload));
      if (res?.payload?.statusCode == 200) {
        handleClose();
        dispatch(classdetailsAction(idval)).setSelectedItems([]);
        toast.success("Learner added successfully!", {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
      } else {
        toast.error(res?.payload?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleAddToTeacher = async (idval) => {
    try {
      const Payload = {
        classId: idval,
        student: selectedItems,
      };
      const res = await dispatch(studentAddToteacherClass(Payload));
      if (res?.payload?.statusCode == 200) {
        handleClose();
        setSelectedItems([]);
        toast.success("Learner added successfully!", {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
      } else {
        toast.error(res?.payload?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // const handleShareClick = async (idval) => {
  //   const urlGroups = groupString.split(',').map(Number);

  //   const isMatch =
  //     urlGroups.length === selectedGroups.length &&
  //     urlGroups.every(group => selectedGroups.includes(group));

  //   if (!isMatch) {
  //     setModalOpen(true);
  //     setSelectedType("sensitiveContent");
  //   } else {
  //     sensitiveContentShare();
  //   }
  // };

  const handleShareClick = async (idval) => {
    let urlGroups = [];
    if (groupString && groupString.trim() !== "") {
      urlGroups = groupString.split(",").map(Number);
    }

    const isMatch =
      urlGroups.length === selectedGroups.length &&
      urlGroups.every((group) => selectedGroups.includes(group));

    if (groupString && !isMatch) {
      setModalOpen(true);
      setSelectedType("sensitiveContent");
    } else {
      sensitiveContentShare();
    }
  };

  const sensitiveContentShare = async () => {
    try {
      const Payload = {
        collectionId: idval,
        studentId: selectedItems,
      };
      const res = await dispatch(
        collectionShareWithPerticulerStudentAction(Payload)
      );
      if (res?.payload?.statusCode == 200) {
        handleClose();
        handleConfirmClose();
        setSelectedItems([]);
        setSelectedGroups([]);
        toast.success("Collection shared successfully!", {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
      } else {
        toast.error(res?.payload?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleShareWithStudent = (id) => {
    // alert("dsfsdfsd")
  };

  const handleConfirmClose = async () => {
    setModalOpen(false);
  };

  return (
    <>
      <Modal
        size="lg"
        show={show}
        onHide={handleClose}
        className="comn-modal-set add-student-set "
      >
        <Modal.Header className="d-block" style={{ border: "0" }}>
          <Row>
            <Col lg={12} className="d-flex justify-content-center mb-4">
              <div>
                {type === "collectionDetailShareStudent" && (
                  <Modal.Title>Share collection with Learner</Modal.Title>
                )}

                {type === "teacherDetailAddStudent" && (
                  <Modal.Title>Add Learners</Modal.Title>
                )}

                {type === "classDetailAddStudent" && (
                  <Modal.Title>Add Learners to Class</Modal.Title>
                )}

                {type === "classDetailAddStudent" && (
                  <p className="text-center mb-0">
                    Select one or more learners you’d like to add to this class.
                    You can search for learners using the bar below.
                  </p>
                )}

                {type === "existCollectionShareWithLearner" && (
                  <Modal.Title>Share class collection with Learner</Modal.Title>
                )}
              </div>
            </Col>
          </Row>
          <div className="modal-right">
            <button className="menu-dots" onClick={handleClose}>
              <img src={require("../Assets/Images/dotsweb.svg").default} />
            </button>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="collection-sec">
            <Row className="justify-content-center">
              <Col lg={8}>
                <SearchBar setSearchValue={setSearchValue} />
              </Col>
            </Row>
            <div className="mt-4">
              {studentData &&
              studentData.student &&
              studentData.student.length > 0 ? (
                <div className="row">
                  <>
                    {studentData.student.map((ele, index) => {
                      return (
                        <>
                          <Col lg={3} key={index}>
                            <div
                              onClick={() => handleClick(ele)}
                              className={
                                selectedItems.includes(ele._id)
                                  ? "active students-list"
                                  : "students-list"
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <img
                                src={
                                  ele?.image
                                    ? ele?.image
                                    : require("../Assets/Images/girl.png")
                                }
                              />
                              {/* <h3>{ele?.userName}</h3> */}
                              {ele?.firstName ? (
                                <h3 className="all-learners-name">
                                  {ele?.firstName} {ele?.surName}
                                </h3>
                              ) : (
                                <h3 className="all-learners-name">N/A</h3>
                              )}
                              {ele?.email && (
                                <abbr
                                  title={ele?.email}
                                  style={{ textDecoration: "none" }}
                                >
                                  <p className="all-learners-mail">
                                    {truncateEmail(ele?.email, 20)}
                                  </p>
                                </abbr>
                              )}
                              {ele?.year && <p>Year {ele?.year}</p>}
                            </div>
                          </Col>
                        </>
                      );
                    })}
                  </>
                </div>
              ) : (
                <div className="data-not-found">
                  <p>No Data Found</p>
                </div>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-none justify-content-center p-4">
          {type === "teacherDetailAddStudent" && (
            <Button
              variant="primary"
              className="modal-f-btn"
              onClick={() => handleAddToTeacher(idval)}
            >
              Add
            </Button>
          )}

          {type === "classDetailAddStudent" && (
            <Button
              variant="primary"
              className="modal-f-btn"
              onClick={() => handleSubmit(idval)}
            >
              Add to Class
            </Button>
          )}

          {type === "existCollectionShareWithLearner" && (
            <Button
              variant="primary"
              className="modal-f-btn"
              onClick={() => handleShareWithStudent(idval)}
            >
              Share
            </Button>
          )}

          {type === "collectionDetailShareStudent" && (
            <Button
              variant="primary"
              className="modal-f-btn"
              onClick={() => handleShareClick(idval)}
            >
              Share
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      <ConfirmModal
        data={{
          collectionId: idval,
          studentId: selectedItems,
        }}
        isModalOpen={isModalOpen}
        selectedType={selectedType}
        handleConfirmClose={handleConfirmClose}
        extraFunction={sensitiveContentShare}
      />
    </>
  );
};

export default StudentsModal;
